import {
    APP_APPCODE_CHANGE_SAGA,
    APP_LOCALE_CHANGE_SAGA,
    APP_UPDATE_PARAMETER_SAGA,
} from "@/Redux/App/AppConstants";

export const updateParameter = (
    parameter: string,
    value: string,
    callback: (err: Error) => void,
) => {
    return {
        type: APP_UPDATE_PARAMETER_SAGA,
        payload: {
            parameter,
            value,
            callback,
        },
    };
};

export const changeLocale = (
    locale: string,
    callback: (err: Error) => void,
) => {
    return {
        type: APP_LOCALE_CHANGE_SAGA,
        payload: {
            locale,
            callback,
        },
    };
};

export const changeAppCode = (
    appCode: string,
    callback: (err: Error) => void,
) => {
    return {
        type: APP_APPCODE_CHANGE_SAGA,
        payload: {
            appCode,
            callback,
        },
    };
};
